import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  StateService,
  ToolService,
  RouterService,
  Machine,
  Inspection,
} from 'projects/shared/src/public-api';
import { Subscription, switchMap } from 'rxjs';
import {
  INSPECTION_GROUPS,
  InspectionGroup,
} from '../../models/inspection-group';

@Component({
  selector: 'lib-inspection-detail',
  templateUrl: './inspection-detail.component.html',
  styleUrls: ['./inspection-detail.component.scss'],
  standalone: false,
})
export class InspectionDetailComponent implements OnInit {
  constructor(
    public state: StateService,
    public tools: ToolService,
    private route: ActivatedRoute,
    public routerService: RouterService,
    public modalCtrl: ModalController
  ) {}

  sub: Subscription;
  paramId: string;
  inspection: Inspection = {};
  INSPECTION_GROUPS = INSPECTION_GROUPS;

  ngOnInit() {
    this.sub = this.state.inspections$.subscribe((x) => {
      this.inspection = x.find((x) => x.id == this.paramId);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  showInViewer() {
    this.modalCtrl.dismiss('view', 'confirm');
  }

  async cancel() {
    return await this.modalCtrl.dismiss(null, 'cancel');
  }

  async approve() {
    this.state.approveInspection(this.inspection.id);
    await this.cancel();
  }

  async edit() {
    await this.modalCtrl.dismiss('edit', 'confirm');
  }

  async delete() {
    await this.state.deleteInspection(this.inspection.id);
    await this.modalCtrl.dismiss('delete', 'confirm');
  }

  groupHasElements(group: InspectionGroup): boolean {
    let hasElements = false;
    group.inspectionElements.forEach((x) => {
      if (this.inspection.inspectionResults[x.name] != null) hasElements = true;
    });
    return hasElements;
  }
}
